<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-6">
        <span class="connecting-state">
          <template v-if="signInMethod === 'microsoft.com'">
            {{ $t('Setup.ConnectingMicrosoft365') }}
          </template>
          <template v-else>
            {{ $t('Setup.ConnectingGSuite') }}
          </template>
        </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-6">
        <template v-if="signInMethod === 'microsoft.com'">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="switchLoginForGSuite"
          >
            <i class="fab fa-microsoft" />
            <i class="fas fa-angle-double-right" />
            <i class="fab fa-google" />
            {{ $t('Setup.Button.ChangeGSuite') }}
          </button>
        </template>
        <template v-else>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="switchLoginForOffice365"
          >
            <i class="fab fa-google" />
            <i class="fas fa-angle-double-right" />
            <i class="fab fa-microsoft" />
            {{ $t('Setup.Button.ChangeMicrosoft365') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('auth', [
      'signInMethod'
    ])
  },
  methods: {
    switchLoginForGSuite() {
      this.$emit('changeLoginGoogle')
    },
    switchLoginForOffice365() {
      this.$emit('changeLoginMicrosoft')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@abeja-inc/abeja-ui-library/scss/_variables.scss";

.connecting-state {
  font-size: $font-size-lg-1;
  font-weight: $font-weight-semibold;
}

</style>
